<div class="panel">
  <div class="border-b border-gray-200">
    <div class="px-8 h-20 items-center flex gap-3">
      <!-- The list heading is the button that opens its menu (TW-PANEL-07): named by its text, Enter and Space native. -->
      <button
        type="button"
        class="bg-transparent border-0 p-0 [font:inherit] text-inherit text-left cursor-pointer"
        appDPContactsContextMenu
        (appDPContextMenuOpened)="contextMenuOpened = $event"
        (appDPContextMenuFilterChanged)="selectFilter($event)"
        aria-haspopup="menu"
        [attr.aria-expanded]="!!contextMenuOpened"
      >
        <app-dropdown-label [collapsed]="!contextMenuOpened">
          {{ selectedFilter | titleByContactsFilter }}
        </app-dropdown-label>
      </button>

      <div class="grow"></div>

      @if (selectedTab !== 'groups') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appContactsListContextMenu
          [appContactsListContextMenuWithAdvancedSearch]="true"
        />
      }
      @if (selectedTab === 'groups') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appGroupsListContextMenu
          [appGroupsListContextMenuWithAdvancedSearch]="true"
        />
      }

      <app-search-state-indicator [applied]="isSearchApplied()" (clear)="clearSearch()">
        <app-icon
          class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center"
          name="search-small"
          stchPopover
          stchPopoverPlacement="bottomRight"
          stchPopoverTrigger="click"
          [stchPopoverContent]="searchPopover"
          [stchPopoverFallbackPlacements]="[]"
          [stchPopoverShowUntil]="popoverClose"
        />
      </app-search-state-indicator>
    </div>
    @if (listState === 'tabs') {
      <app-tabs class="panel-heading-tabs" [values]="tabs" [(value)]="selectedTab" />
    }
  </div>

  @if (selectedTab === 'groups' && creationAllowed() && quickGroup) {
    <app-quick-form
      class="panel-quick-form"
      trigger="button"
      [collapseKey]="selectedFilter"
      placeholder="Add New Group"
    >
      <app-group-quick-form [group]="quickGroup" [showMore]="true" (more)="handleNewGroup($event)" />
    </app-quick-form>
  }

  @if (selectedTab === 'contacts' && creationAllowed() && quickContact) {
    <app-quick-form
      class="panel-quick-form"
      trigger="button"
      [collapseKey]="selectedFilter"
      placeholder="Add New Contact"
    >
      <app-contact-quick-form
        [contact]="quickContact"
        [showMore]="true"
        [destinationTenantId]="contactsTenantScope?.effectiveTenantId() ?? undefined"
        (more)="openContactInModal($event)"
      />
    </app-quick-form>
  }

  <div class="panel-list border-t border-gray-200">
    @if (selectedTab === 'groups' && groupsFilters) {
      <app-groups-list
        [filters]="groupsFilters"
        [tenantItems]="searchTenantItems ?? listTenantItems"
        (openGroup)="openGroup($event)"
        (openContact)="openContactInModal($event)"
        (doubleClickGroup)="openGroup($event)"
      />
    }

    @if (selectedTab !== 'groups' && contactsFilters) {
      <app-contacts-list
        [filters]="contactsFilters"
        [tenantItems]="searchTenantItems ?? listTenantItems"
        [showLocationBadge]="isAdvancedSearchApplied()"
        (openContact)="openContact($event)"
        (doubleClickContact)="openContact($event)"
      />
    }
  </div>
</div>

<ng-template #searchPopover>
  <app-contacts-search-popover [width]="600" (onSearch)="handleSearch()" (onCancel)="handleCancel()" />
</ng-template>
